import { SxProps, Theme } from '@mui/material';

/**
 * Common icon size styles to replace inline sx={{ fontSize: 'Xpx' }}
 * Usage: <Icon sx={iconStyles.sm} /> or <Icon sx={iconStyles.md} />
 */
export const iconStyles = {
  xs: { fontSize: '12px' } as SxProps<Theme>,
  sm: { fontSize: '14px' } as SxProps<Theme>,
  md: { fontSize: '16px' } as SxProps<Theme>,
  ml: { fontSize: '18px' } as SxProps<Theme>,
  lg: { fontSize: '20px' } as SxProps<Theme>,
  xl: { fontSize: '24px' } as SxProps<Theme>,

  circleIcon: {
    color: 'white',
    fontSize: '24px',
  } as SxProps<Theme>,

  circleIconLg: {
    color: 'white',
    fontSize: '32px',
  } as SxProps<Theme>,

  successCheck: {
    fontSize: '16px',
    color: 'success.main',
    flexShrink: 0,
  } as SxProps<Theme>,

  disabledIcon: {
    fontSize: '16px',
    color: 'text.disabled',
    flexShrink: 0,
  } as SxProps<Theme>,

  secondary: {
    color: 'text.secondary',
    fontSize: '20px',
  } as SxProps<Theme>,
};
